import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { UserRole } from '../enums/user-role.enum';

@Injectable({ providedIn: 'root' })
export class RoleLandingRedirectGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(): Observable<boolean | UrlTree> {
    const role = (localStorage.getItem('userRole') as UserRole) || '';
    switch (role) {
      case UserRole.FARM_ADMIN:
        return of(this.router.createUrlTree(['/trials']));
      case UserRole.VIVENT_ADMIN:
        return of(this.router.createUrlTree(['/distributors']));
      case UserRole.DISTRIBUTOR:
        return of(this.router.createUrlTree(['/endclients']));
      case UserRole.BASIC:
        return of(this.router.createUrlTree(['/trials']));
      default:
        return of(this.router.createUrlTree(['/login']));
    }
  }
}
